import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MessageContent } from '../../interfaces/MessageContent';
import { MessagesFacade } from '../../_services/messages.facade';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MessageRecepientsComponent } from '../message-recepients-popup/message-recepients.component';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-message-view',
  templateUrl: './message-view.component.html',
  styleUrls: ['./message-view.component.scss']
})
export class MessageViewComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  messageContent: MessageContent;
  currLang;
  safeHTML;

  constructor(private messageFacade: MessagesFacade, private router: Router, public dialog: MatDialog,
    private domSanitizer: DomSanitizer,
    private globalService: GlobalService,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<MessageViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  ngOnInit(): void {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.messageContent = {
      messageContent: this.data.content,
      attachments: this.data.attachments
    }
    this.safeHTML = this.domSanitizer.bypassSecurityTrustHtml(this.messageContent.messageContent);
  }

  duplicateMessage() {
    this.messageFacade.getCurrentMessage$().pipe(takeUntil(this.destroy$)).subscribe(data => {      
      this.router.navigateByUrl('messages/create-messages', { state: data })
    })
    this.dialogRef.close();
  }

  deleteMessage() {
    this.messageFacade.getCurrentMessage$().pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.messageFacade.deleteMessage(data[0].id).subscribe(res => {
        this.dialogRef.close();
        this.messageFacade.loadAllMessages();
      })
    })
  }

  openMessageViewers() {
    let viewers = [];
    viewers = this.data.recipients.filter((rec: any) => rec.pivot.is_read === 1)
    const dialogRef = this.dialog.open(MessageRecepientsComponent, {
      width: '90vw',
      data: viewers,
      disableClose: true
    });
  }

  openMessageRecepients() {
    const dialogRef = this.dialog.open(MessageRecepientsComponent, {
      width: '60vw',
      data: this.data.recipients,
      panelClass: 'my-class',
      disableClose: true
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
